import { Routes } from "@angular/router";

import { authGuardFn } from "@auth0/auth0-angular";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
    // loadComponent: () => import("./modules/home/home").then(m => m.Home),
    // pathMatch: "full"
  },
  {
    path: "login",
    loadComponent: () => import("./modules/login/login").then(m => m.Login),
  },
  {
    path: "chat",
    loadComponent: () => import("./modules/chat/chat").then(m => m.Chat),
    pathMatch: "full",
    canActivate: [authGuardFn],
  },
];
